// extracted by mini-css-extract-plugin
export var active = "Header-module--active--ejVfX";
export var header = "Header-module--header--Do7F3";
export var link = "Header-module--link--ptHUm";
export var logoWrapper = "Header-module--logo-wrapper--zUlRK";
export var navigation = "Header-module--navigation--Zp75p";